import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatures } from '@/lib/features';

/** Dispute screens are only reachable while the admin keeps dispute handling switched on. */
export function DisputesGate({ children, to = '/buyer' }) {
  const features = useFeatures();
  if (!features.disputes_enabled) return <Navigate to={to} replace />;
  return children;
}
